import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TenantService } from '../../../../Services';
import { MaintenanceTask, MaintenanceTaskRun } from '../Models/MaintenanceTask';
import { ValidationResult } from '../Services/import.service';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceTasksService {


    private baseUrl = "/api/maintenance/";
  constructor(private http: HttpClient, private tenantService : TenantService) { }

  getTasks() : Observable<MaintenanceTask[]>{
    let url = `${this.baseUrl}${this.tenantService.selectedTenant.Value}/tasks`;
    return this.http.get<MaintenanceTask[]>(url);
  }

  executeTask(task: MaintenanceTask) : Observable<string> {
    let url = `${this.baseUrl}${this.tenantService.selectedTenant.Value}/execute/${task.TypeName}`;
    return this.http.post<string>(url, task.RunConfig || {});
  }

  getHistory(task: MaintenanceTask) :Observable<MaintenanceTaskRun[]>{
    let url = `${this.baseUrl}${this.tenantService.selectedTenant.Value}/${task.TypeName}/runs`;
    return this.http.get<MaintenanceTaskRun[]>(url);
    }

    uploadFile(file: File, task: MaintenanceTask): Observable<ValidationResult> {
        const formData = new FormData();
        formData.append('file', file, file.name)

        const headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        const options = { headers };

        let url = `${this.baseUrl}${this.tenantService.selectedTenant.Value}/upload/${task.TypeName}`
        return this.http.post<ValidationResult>(url, formData, options);
    }

    downloadTemplate(task: MaintenanceTask): void {
        const tenantId = this.tenantService.selectedTenant.Value;
        const url = `${this.baseUrl}${tenantId}/template/${task.TypeName}`;
        this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
            const objectUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = task.CsvTemplateFileName ?? `${task.TypeName}-template.csv`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(objectUrl);
        });
    }
}
